module.exports = __webpack_public_path__ + "img/Judo.8e96d8dd.png";